import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** @see docs/API_SYSTEM_ACCESS.md */
export async function createRole(payload) {
  const { data: raw } = await request.post('/system/role', keysToSnake(payload));
  return parseVer4DetailResponse(raw);
}
